import { render, staticRenderFns } from "./CRMSum.vue?vue&type=template&id=2f2ea322&scoped=true"
import script from "./CRMSum.vue?vue&type=script&lang=js"
export * from "./CRMSum.vue?vue&type=script&lang=js"
import style0 from "./CRMSum.vue?vue&type=style&index=0&id=2f2ea322&prod&lang=less"
import style1 from "./CRMSum.vue?vue&type=style&index=1&id=2f2ea322&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2ea322",
  null
  
)

export default component.exports